/**
 * 获取文件后缀
 */
export const getFileType = (contentType = '', fileName = '') => {
  const lastIndex = fileName.lastIndexOf('.');
  return fileName.substring(lastIndex + 1).toLowerCase();
}

/**
 * 判断是否为 zip 文件
 * @param fileName
 */
export const isZip = (fileName = '') => {
  const type = getFileType('', fileName) || '';
  return 'zip' == type.toLowerCase();
}

/**
 * 判断是否为 pdf 文件
 * @param fileName
 */
export const isPdf = (fileName = '') => {
  const type = getFileType('', fileName) || '';
  return 'pdf' == type.toLowerCase();
}

/**
 * 提取文件名称
 * @param name
 */
export const getName = (name = '') => {
  return name;
}
